export enum TransactionStatus {
  payment_request = 'payment-request',
  draft = 'draft',
  paid = 'paid',
  refunded = 'refunded',
  disputed = 'disputed',
  pre_transaction = 'pre-transaction',
  failed = 'failed',
  pending = 'pending',
  retrying = 'retrying',
  canceled = 'canceled',
  requiresAction = 'requiresAction',
  maxAttemptsReached = 'maxAttemptsReached',
}
